<aurora-menu aurora-light [items]="menuItems" (item-click)="onMenuItemClick($event)"></aurora-menu>
